<template>
        
    <!-- Page header -->
	<div class="page-header page-header-light shadow">

		<!-- breadcrumb -->
		<div class="page-header-content d-lg-flex">
			<div class="d-flex">
				<h4 class="page-title mb-0">
					<router-link href="#" class="mb-xs-1 text-dark cursor-pointer" :to="'Dashboard'"><i class="icon-arrow-left52 me-1"></i></router-link>
                    <a href="#" class="hidden-xs text-dark fw-semibold cursor-pointer" v-on:click="getInvoices()"> Contabilità </a>
					<span class="hidden-xs ms-1">\</span>
                    <span class="text-muted ms-1"><Translate :path="'dizionario.base.GESTIONE'"></Translate> Fatture</span>
                </h4>
				<a href="#page_header" class="hidden-lg btn btn-light align-self-center collapsed border-transparent rounded-pill p-0 ms-auto" data-bs-toggle="collapse">
					<i class="ph-caret-down collapsible-indicator ph-sm m-1"></i>
				</a>
            </div>
			<div class="collapse d-lg-block my-lg-auto ms-lg-auto text-center" id="page_header">
				<div class="d-sm-flex align-items-center mb-3 mb-lg-0 ms-lg-3">

					<a href="#" class="d-inline-flex align-items-center text-body lh-1 py-sm-2 position-10" style="text-align: left;" v-on:click="addInvoice(1)">
						<i class="ph-plus fw-bold me-2 btn btn-outline-success w-32px h-32px rounded-pill"></i>
						<div class="me-auto me-lg-1 ms-1">
							<div class="fs-sm text-muted mb-0">
								<Translate :path="'dizionario.base.BTN_NUOVA'"></Translate> Fattura
							</div>
							<div class="text-success fw-semibold"><Translate :path="'dizionario.base.BTN_ADD'"></Translate></div>
						</div>
					</a>

					<div class="vr flex-shrink-0 my-2 mx-3"></div>

					<div class="d-inline-flex float-end mt-sm-0">
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill" v-on:click="$root.confTravelTipologiche(10)" title="Opzioni Utenti" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-lightning"></i>
						</a>
						<a href="#" class="btn btn-outline-light btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.confTravelLingue(102)" title="Definizioni Lingua" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="ph-flag"></i>
						</a>
						<a href="#" class="btn btn-outline-pink btn-icon w-32px h-32px squared-pill ms-2" v-on:click="$root.help(10)" title="Help OnLIne" data-bs-toggle="tooltip" data-bs-placement="left">
							<i class="icon-question7 pink"></i>
						</a>
					</div>
				</div>
			</div>
		</div>
		<!-- /breadcrumb -->

		<!-- Profile navigation -->
		<div class="navbar navbar-expand-lg border-top py-1">
			<div class="container-fluid">
				<ul class="nav navbar-nav flex-row flex-fill" role="tablist">
					<li class="nav-item me-1" role="presentation">
						<a href="#invoices-a" class="navbar-nav-link navbar-nav-link-icon navbar-sm active rounded" data-bs-toggle="tab" aria-selected="true" role="tab" tabindex="-1">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-list"></i>
								<span class="hidden-lg ms-1">Fatture</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.ELENCO'" class="me-1"></Translate>Fatture</span>
							</div>
						</a>
					</li>
					<li class="nav-item me-1" role="presentation">
						<a href="#invoices-b" class="navbar-nav-link navbar-nav-link-icon navbar-sm rounded" data-bs-toggle="tab" aria-selected="false" role="tab" tabindex="-1" v-on:click="statisticheStartup();">
							<div class="d-flex align-items-center mx-lg-1">
								<i class="ph-activity"></i>	
								<span class="hidden-lg ms-1">Stats.</span>
								<span class="hidden-xs ms-1"><Translate :path="'dizionario.base.BTN_STATISTICHE'"></Translate></span>
							</div>
						</a>
					</li> 
					<li class="nav-item d-lg-none ms-auto">
						<a href="#profile_nav" class="navbar-nav-link navbar-nav-link-icon rounded-pill rounded-pill-small collapsed" data-bs-toggle="collapse" aria-expanded="false">
							<i class="ph-caret-down collapsible-indicator"></i>
						</a>
					</li>
				</ul>

			    <Datepicker autocomplete="off" class="ms-lg-auto bg-light text-center mt-xs-1" style="width:320px;" v-model="intervalloDate" range multi-calendars multi-calendars-solo :formats="{ input: 'dd/MM/yyyy' }" auto-apply :hide-navigation="['time']" :partial-range="false" placeholder="Data Ordine da > a" :tabindex="2" />
				<span class="btn btn-primary btn-sm ms-1" v-on:click="getInvoices()">AGGIORNA</span>

				<div class="navbar-collapse collapse" id="profile_nav">
					<ul class="navbar-nav ms-lg-auto mt-2 mt-lg-0 select-small">
						<li class="nav-item dropdown ms-lg-1">
							<div class="btn-group">
								<a href="#" class="btn btn-flat-indigo border-transparent btn-sm dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false">
									<i class="ph-gear me-1"></i>
									<span style="font-size:0.8rem;">Azioni Multiple</span>
								</a>
								<div class="dropdown-menu dropdown-menu-end" style="">
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-ballot-check fa-fw me-2"></i><span class="text-muted me-1">|</span>Stato</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-check-square fa-fw me-2"></i>Attiva selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-square fa-fw me-2"></i>Disattiva selezionati</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Comunicazioni</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia Email</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Invia SMS</a>
										</div>
									</div>
									<div class="dropdown-submenu dropdown-submenu-start">
										<a href="#" class="dropdown-item"><i class="far fa-file-export fa-fw me-2"></i><span class="text-muted me-1">|</span>Esporta dati</a>
										<div class="dropdown-menu">
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Pagina corrente</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Utenti selezionati</a>
											<a href="#" class="dropdown-item"><i class="far fa-file-excel fa-fw me-2"></i>Tutti gli Utenti</a>
										</div>
									</div>
									<div class="dropdown-divider"></div>
									<a href="#" class="dropdown-item"><i class="far fa-trash fa-fw me-2 text-danger"></i><span class="text-muted me-1">|</span>Elimina selezionati</a>
								</div>
							</div>
						</li>
						<li class="nav-item">
	
						</li>
					</ul>
				</div>
			</div>
		</div>
		<!-- /profile navigation -->	

	</div>
	<!-- /page header -->

    <!-- Content area -->
    <div class="content content-1 table-cms-wrapper">
		<div class="tab-content flex-1 order-2 order-lg-1">

			<div class="tab-pane fade active show" id="invoices-a">
				<div class="card shadow mb-xs-3 mb-lg-0">
					<div class="card-header d-lg-none p-1">
						<div class="d-grid gap-2">
							<a href="#collapse-all" class="btn btn-flat-info btn-sm collapsed" data-bs-toggle="collapse" role="button" aria-expanded="false">
								MOSTRA FILTRI
							</a>
						</div>
					</div>
					<div class="collapse show" id="collapse-all" style="">				
						<div class="card-body pb-0">
							<div class="alert alert-2 alert-secondary border-0">
								<form autocomplete="off" action="#" id="invoice-a">
		                            <div class="row ">	
	                                    <div class="col-6 col-md-1 mbx-1">
	                                        <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Id invoice" :tabindex="2" v-model="search.ID_INVOICE.VALUE" />
	                                    </div> 
	                                    <div class="col-6 col-md-1 mbx-1">
	                                        <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Pnr pratica" :tabindex="2" v-model="search.PNR.VALUE" />
	                                    </div>  
	                                    <div class="col-12 col-md-2 mbx-1">
	                                        <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Intestatario" :tabindex="3" v-model="search.INTESTATARIO.VALUE" />
	                                    </div>	 
	                                    <div class="col-12 col-md-2 mbx-1">
	                                        <input autocomplete="off" class="form-control form-control-sm" type="text" placeholder="Descrizione" :tabindex="3" v-model="search.TITOLO_PRATICA.VALUE" />
	                                    </div>  
										<div class="col-12 col-md-2 mbx-1">
											<select class="form-select form-select-sm" data-placeholder="Saldo" tabindex="4"> 
												<option>Movimento</option> 
												<option v-bind:value="0"> - Banca</option> 
												<option v-bind:value="1"> - Contanti</option>
											</select>
										</div>
										<div class="col-12 col-md-2 mbx-1">
											<select class="form-select form-select-sm" data-placeholder="Stato Invoices">
												<option>Stato Invoices</option> 
												<option v-bind:value="0"> - Da Emettere</option> 
												<option v-bind:value="1"> - Emessa</option>                                                                    
											</select>
										</div>
										<div class="col-12 col-md-2 mbx-1">
											<a href="#collapse-icon" class="btn btn-secondary btn-sm btn-block collapsed" data-bs-toggle="collapse" aria-expanded="false" :tabindex="12">
												<span style="font-weight: 500;"><i class="far fa-plus fa-fw"></i></span>
											</a>
	                                    </div>  
	                                </div>
	                        	</form>
	                        </div>
	                    </div>
	                </div>
	
					<div class="card-body box-card mt-0 mb-0" id="box-card">
						<div class="div_table_resp tableFixHead" id="tableFixHead">
		               		<table class="table table-bordered table-hover table-striped table-togglable text-nowrap"> 
			                    <thead class="sticky-top">
									<tr class="bg-secondary text-white">
	                                    <th class="hidden-xs table-head-sm" style="width: 2%;"> <input id="chkAllInvoices" v-on:click="filters.selectAll('chkAllInvoices',paginatedList.arr)" type="checkbox" class=""> </th>
	                                    <th class="table-head-sm" style="width: 6%;">  #<ISort class="float-end" v-model="ordinamento"  :campo="'DESCRIZIONE'"></ISort><br /><span class="float-end">Ord. </span></th>
	                                    <th class="table-head-sm text-center" style="width: 7%;">Data Emissione</th>
	                                    <th class="table-head-sm" style="width: 19%;"> Intestatario<br>&nbsp;</th>
	                                    <th class="table-head-sm text-center"> Descrizione </th>
	                                    <th class="table-head-sm text-center" style="width: 8%;"> Importo </th>	
										<th class="table-head-sm text-center" style="width: 7%;">Data scadenza</th>
	                                    <th class="table-head-sm text-center" style="width: 10%;">Stato</th>
										<th class="table-head-sm text-center" style="width:5%;">Stato</th>
	                                    <th class="table-head-sm text-center" style="width:5%;">Azioni</th>
	                                </tr>
	                            </thead>
	                            <tbody>
	                                <tr v-for="invoice in paginatedList.arr" v-bind:key="invoice.ID_INVOICE">
	                                    <td class="hidden-xs td-class text-center">
											<span class="footable-toggle"></span>
											<input type="checkbox" v-bind:true-value="1" v-bind:false-value="0" v-model="invoice.SELEZIONATO" class=""> 
										</td>
	                                    <td class="td-class fs-sm">
											<span>{{filters.getPnr(invoice)}}</span><br />
											<small class="badge bg-light badge-xs text-primary cursor-pointer float-end"> &nbsp; </small>
										</td>
	                                    <td class="td-class text-center"> 
											{{filters.formatDate(invoice.DATA_CREAZIONE)}}
										</td>
	                                    <td class="td-class fs-sm">
	                                        <span class="badge" v-bind:class="getTipoBookClass(invoice)">{{getTipoBook(invoice)}}</span> - 
	                                        <span class="text-secondary fw-bold" v-show="invoice.FK_ID_AGENCY > 0">{{ invoice.AGENZIA }}</span>
	                                        <span class="text-secondary fw-bold" v-show="invoice.FK_ID_AGENCY == 0 && invoice.INTESTATARIO_FK_ID_PERSONA_FISICA > 0">{{ invoice.INTESTATARIO_PERSONA_FISICA }}</span>
	                                        <span class="text-secondary fw-bold" v-show="invoice.FK_ID_AGENCY == 0 && invoice.INTESTATARIO_FK_ID_PERSONA_GIURIDICA > 0">{{ invoice.INTESTATARIO_PERSONA_GIURIDICA }}</span>
	                                    </td>
	                                    <td class="hidden-xs td-class fs-sm"></td>
	
	
	
	                                    <td class="hidden-xs td-class fs-sm"><strong>&euro; {{invoice.PREZZO_TOTALE}} </strong></td>
										<td class="hidden-xs td-class fs-sm"> Bonifico </td>
	
	                                    <td class="text-center">
	                                        <span class="badge badge-danger cursor-pointer">Da pagare</span>
	                                    </td>        
	                                    <td class="td-class text-center">
	                                        <span class="badge badge-warning cursor-pointer" v-on:click="openCatturaInvoice()"><i class="far fa-thumbs-down"></i></span>
	                                    </td>
										<td class="td-class text-center">
											<div class="dropdown">
												<a href="#" class="text-body" data-bs-toggle="dropdown" aria-expanded="false">
													<i class="ph-list"></i>
												</a>
												<div class="dropdown-menu dropdown-menu-end">
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs">Gestione</div>
                                                    <a href="#" class="dropdown-item" v-on:click="openInvoice(invoice)"><i class="fad fa-pencil fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Modifica invoice</a>
                                                    <div class="dropdown-divider"></div>
                                                    <a href="#" class="dropdown-item" v-on:click="openInvoice(invoice)"><i class="fad fa-eye fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Anteprima invoice</a>
                                                    <a href="#" class="dropdown-item" v-on:click="openInvoice(invoice)"><i class="fad fa-paper-plane fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Invia invoice</a>
													<div class="dropdown-header text-uppercase font-size-xs line-height-xs">Admin</div>
                                                    <a href="#" class="dropdown-item" v-on:click="deleteInvoice(invoice)"><i class="fad fa-copy fa-lg fa-fw me-2"></i><span class="text-muted me-1">|</span>Copia invoice</a>
                                                    <a href="#" class="dropdown-item" v-on:click="deleteInvoice(invoice)"><i class="fad fa-trash fa-lg fa-fw text-danger me-2"></i><span class="text-muted me-1">|</span>Elimina invoice</a>
	                                            </div>
	                                        </div>
	                                    </td>
	                                </tr>
	                            </tbody>
	                        </table>
	                    </div>
	
		                <div class="row page-bottom">
							<div class="col-12 col-md-5 d-none d-sm-block" :tabindex="27">
                                <div style="position: relative; top: 10px;">
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2"><span>FATTURE</span>: {{ paginatedList.count }}</span> 
                                    <span class="badge bg-secondary bg-opacity-20 text-secondary rounded-0 p-2 ms-2">FATTURATO: </span>
                                </div>
                            </div>
							<div class="col-9 col-md-6" :tabindex="27">
		                        <div class="float-end pag-mobile">
			                        <Pagine v-model="search.PAGINATION.PAGE_NUMBER" :numrighe="paginatedList.count" :numpagine="search.PAGINATION.LENGTH"></Pagine>
		                        </div>
		                    </div>
		                    <div class="col-3 col-md-1" :tabindex="28">
		                        <select class="form-select form-select-sm wmin-100 mt-2 float-end" data-placeholder="Limite" :tabindex="20" v-model="search.PAGINATION.PAGE_SIZE" style="position: relative; top: 0px; padding: 0.4375rem 0.5rem;">
		                            <option value="5">5</option>
		                            <option value="10">10</option>
		                            <option value="25">25</option>
		                            <option value="50">50</option>
		                            <option value="75">75</option>
		                            <option value="100">100</option>
		                            <option value="250">250</option>
		                            <option value="500">500</option>
		                        </select>
		                    </div>
			       		</div>
	                </div>
	            </div>
			</div>	
			
			<div class="tab-pane fade" id="invoices-b">

				<div class="row">
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-users ph-2x text-primary me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Totale </span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-up ph-2x text-success me-3"></i>

								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted"> attivi</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<i class="ph-thumbs-down ph-2x text-danger me-3"></i>
								<div class="flex-fill text-end">
									<h4 class="mb-0"></h4>
									<span class="text-muted"> 0 pratiche</span>
								</div>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"></h4>
									<span class="text-muted">bannati</span>
								</div>
								<i class="ph-house-simple ph-2x text-danger ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"> </h4>
									<span class="text-muted">Tot. Fatturato  </span>
								</div>
								<i class="ph-sketch-logo ph-2x text-indigo ms-3"></i>
							</div>
						</div>
					</div>
					<div class="col-sm-6 col-xl-2">
						<div class="card card-body mb-2">
							<div class="d-flex align-items-center">
								<div class="flex-fill">
									<h4 class="mb-0"></h4>
									<span class="text-muted">Tot. Fatturato  </span>
								</div>
								<i class="ph-globe-hemisphere-east ph-2x text-purple ms-3"></i>
							</div>
						</div>
					</div>
				</div>
				
				<Statistiche :ref="'statistiche'"></Statistiche>

			</div>
	
		</div>
	</div>
				  

	<!-- START MODALI -->
    <div class="modal fade" id="popUpCatturaInvoice" role="dialog" >
		<div class="modal-dialog">
			<div class="modal-content">
				<div class="modal-header modal-header-2 bg-secondary text-white">
                    <h6 class="modal-title">
                        <i class="fal fa-location fa-fw fa-lg" style="color:#FFF;"></i> <span style="top: -1px; position: relative;"> IMPORTA DATI NEL GESTIONALE </span>
                    </h6>
                    <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">X</button>
                </div>
                <div class="modal-body">  

                    <p class="text-center" style="font-size: 14px;">
                        <span id="modal_status_subtitle">sei sicuro di voler importare questa Pratica nel tuo Gestionale?</span> <br> 
                        <span id="modal_status_accept">Proseguendo, la Pratica e le relative Quote, saranno importate nel tuo Gestionale.</span>
                    </p> 
                    <hr> 
                    <div class="row">
                        <div class="col-md-6">
                            <h6><strong>1.</strong> Seleziona Gestionale</h6> 
                            <div class="form-group">
                                <select name="order_status" class="form-control form-control-sm" disabled="disabled">
                                    <option value="easy">Cattura Easy</option>
                                </select>
                            </div>
                        </div> 
                        <div class="col-md-6">
                            <h6><strong>2.</strong> Scegli Operazione</h6>
                            <div class="form-group">
                                <select class="form-control form-control-sm" disabled="disabled">
                                    <option value="Set_Pratica">Importa pratica</option> 
                                    <option value="Set_Quota">Importa quota</option> 
                                    <option value="Set_Invoices">Importa incasso</option> 
                                    <option value="anagrafica">Importa anagrafica</option> 
                                    <option value="voucher">Importa voucher</option>
                                </select>
                            </div>
                        </div> 
                    </div>

                </div>
                <div class="modal-footer bg-light">
                    Vuoi Procedere&nbsp;&nbsp;&nbsp;
                    <button type="button" class="btn btn-secondary btn-sm" data-bs-dismiss="modal">NO ESCI</button>&nbsp;
                    <button type="button" class="btn btn-success btn-sm">SI IMPORTA</button><!--  v-on:click="sendStatus()" -->
                </div>
            </div>
        </div>
    </div>  


</template>



<script>

import Pagine from '@/components/utils/Pagine.vue'
import ISort from '@/components/utils/ISort.vue'
import { VueDatePicker as Datepicker } from '@vuepic/vue-datepicker'
 

export default {
    name:"Invoice",		

    components:{
        Pagine,
		ISort,
        Datepicker,

    },

    data:function(){
        return {
            apiStartup:'travel/invoices',
            filters:global.filters,
			GLOBAL_IMAGES_PATH:'',
			anno:new Date().getFullYear(),
            arrayInvoices:new Array(),
            invoiceSelezionata:{},
            search:{
	            PAGINATION:{LENGTH:0,PAGE_NUMBER:1,PAGE_SIZE:25},
                ANNO_ORDINE:{TYPE:'COMBO',VALUE: new Date().getFullYear()},
	            ID_INVOICE:{TYPE:'TEXT',VALUE:''},
                PNR:{TYPE:'TEXT',VALUE:''},
                CODICE_ORDINE:{TYPE:'TEXT',VALUE:''},
                FK_ID_STATO:{TYPE:'COMBO',VALUE: 0},
	            INTESTATARIO:{TYPE:'TEXT',VALUE:''}, 
	            TITOLO_PRATICA:{TYPE:'TEXT',VALUE:''}, 
                FK_ID_TIPO:{TYPE:'COMBO',VALUE:''},
                FK_ID_FORNITORE:{TYPE:'COMBO',VALUE:''},               
	            FLG_ATTIVO:{TYPE:'COMBO',VALUE:'1'},   

	        },
		    ordinamento:'',
			intervalloDate:{},
			dataStart:'',
			dataEnd:'',

        }
    },

    methods:{
        getInvoices : function(){
            utils.ajax(this.apiStartup,{ANNO_ORDINE:this.search.ANNO_ORDINE.VALUE}, (response) => {
                if (response.esito == 0){
                    this.arrayInvoices = response.data;
                }
            });  
        },

        nuovaInvoice : function(){ 
			this.invoiceSelezionata = {ID_INVOICE:0,FK_ID_MODULO:0,FLG_ATTIVO:1};
            this.filters.openPopUp("popUpInvoice");
        },

        modificaInvoice : function(invoice){
            this.invoiceSelezionata = utils.clone(invoice);
			this.filters.openPopUp("popUpInvoice"); 
        },

        salvaInvoice : function(){
            var api = this.invoiceSelezionata.ID_INVOICE > 0 ? "travel/invoices/update" : "travel/invoices/insert";
            utils.ajax(api,this.invoiceSelezionata, (response) => {
                if (response.esito == 0){
                    utils.alert.success(response.messaggio);
                    this.filters.closePopUp("popUpInvoice");  
                    utils.ajax(this.apiStartup,{}, (response) => {
                        this.arrayInvoices = response.data;
                    });
                }
            });
        }, 

       	openInvoice : function(invoices){
            this.$root.invoiceSelezionata = utils.clone(invoices);
            global.router.push("Invoice");
        },
		
        getBtnStatusClass : function(invoices){
            switch (invoices.FK_ID_STATO){
                case 1:
                    return 'badge-success'
                case 2:
                    return 'badge-primary'
                case 3:
                    return 'badge-info'
				case 4:
                    return 'badge-warning'
                case 5:
                    return 'badge-yellow'
                case 6:                
                    return "badge-secondary";
                case 7:
                case 8:
                    return 'badge-danger'
                default :
                    return 'badge-light'
            }
        },

        openStatoInvoice : function(){
			this.invoiceSelezionata = {ID_INVOICE:0};
			this.filters.openPopUp('#popUpStatoInvoice');
        },

        openCatturaInvoice : function(){
            this.invoiceSelezionata = {ID_INVOICE:0};
			this.filters.openPopUp("popUpCatturaInvoice");
        },	  

        openSchedaInvoice : function(invoices){
            this.$refs.schedaInvoice.openSchedaInvoice(invoices);
        }

    },

    computed: {
        paginatedList(){
            var arr = utils.inGrid(this.arrayInvoices, this.search, this.ordinamento);
	      	return arr;
        },
    }, 

	watch:{
	
	},

    created : function(){
        global.utils.BASE_API = process.env.VUE_APP_API_URL;
        this.GLOBAL_IMAGES_PATH = process.env.VUE_APP_GLOBAL_IMAGES_PATH;
        this.invoiceCorrente = utils.clone(this.$root.invoice);
        utils.ajax(this.apiStartup,{}, (response) => {
           this.arrayInvoices = response.data;
        });
    },

}
</script>

<style scoped>
	.grafico { min-height: 451px; }	
</style>

